import React from "react";
import Cotizacion from "../../components/CotizacionAccidentePersonal/CotizacionAccPersonal";

const ContainerCotizacionAPersonal = () =>
  <main className="bg-light">
    <div className="cr-content container-fluid">
      <div className="container-body-spaces">
        <Cotizacion />
      </div>
    </div>
  </main>

export default ContainerCotizacionAPersonal
